import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import topValidation from 'top-validation';
import '@/scss/design.scss';

// 共通で使うヘッダー高さを取得する関数
const getHeaderHeight = () => {
  const header = document.querySelector(".header") || document.querySelector("header");
  return header ? header.offsetHeight : 0;
};

/*----------------------------------------
 スクロール連動処理（サイドバー・SPバナー・トップへ戻る）の統合
------------------------------------------*/
window.addEventListener('scroll', () => {
  requestAnimationFrame(() => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const footer = document.querySelector('footer');
    
    // ページトップボタン
    const pageTop = document.querySelector('.pagetop');
    if (pageTop) {
      if (scrollTop > 200) {
        pageTop.classList.add('js_active');
      } else {
        pageTop.classList.remove('js_active');
      }
    }

    // SPバナー / サイドバナー
    if (footer) {
      const footerOffset = footer.offsetTop;
      const bnrElements = document.querySelectorAll('.side_bnr, .sp_bnr');
      if (scrollTop > 200 && (scrollTop + windowHeight <= footerOffset)) {
        bnrElements.forEach(el => el.classList.add('js_active'));
      } else {
        bnrElements.forEach(el => el.classList.remove('js_active'));
      }
    }
  });
}, { passive: true });



$(function () {
  // スムーススクロール
    $('a[href^="#"]').click(function(){
      let speed = 1000;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });
});

/*----------------------------------------
　初期化処理
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

$(function() {
  const active = 'is-active';
  /*------------ ハンバーガーボタン開閉 ------------*/
  const btnTrigger = document.querySelector('.btn-trigger');
  const hdNavWrap = document.querySelector('.hd_nav_wrap');
  
  if (btnTrigger && hdNavWrap) {
    btnTrigger.addEventListener('click', function() {
      this.classList.toggle(active);
      hdNavWrap.classList.toggle(active);
    });
  }
});

/*----------------------------------------
　カテゴリーリストの初期 active 付与
------------------------------------------*/
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".category_list li a");
  if (tabs.length === 0) return;

  tabs[0].classList.add("active");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
    });
  });
});

/*----------------------------------------
　contact MWWP Form お問い合わせ・確認画面のアンカー設定（重複を統合・バグ修正）
------------------------------------------*/
window.addEventListener('load', () => {
  const headerHeight = getHeaderHeight();
  const isContactPage = $('.contact_block, .contact_inner').length > 0;

  if (isContactPage) {
    let selectEle = document.querySelector("select");
    if (selectEle) {
      selectEle.outerHTML = `<div class="select_wrap">${selectEle.outerHTML}</div>`;
    }
    topValidation();
  }

  const formElement = document.querySelector('.form_unit');
  const confirmEle = document.querySelector('.contact_confirm');
  const completeEle = document.querySelector('.contact_block');

  if (confirmEle || completeEle) {
    location.hash = '#scroll';
  }

  const backBtn = document.querySelector('.is_back');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      location.hash = '#scroll';
    });
  }

  if (formElement && location.hash == '#scroll') {
    const posy = formElement.offsetTop - headerHeight;
    window.scrollTo({ top: posy, behavior: 'smooth' });
  }
});

// エラー時のスクロール（headerHeight のバグを修正）
document.addEventListener("DOMContentLoaded", function () {
  if ($('.contact_block, .contact_inner').length > 0) {
    const errorElement = document.querySelector('.error');
    if (errorElement) {
      document.querySelector('.mw_wp_form').classList.add('mw_wp_form_error');
      const headerHeight = getHeaderHeight(); // スコープ内で正しく取得
      const position = errorElement.parentElement.offsetTop - headerHeight;
      window.scrollTo({ top: position, behavior: 'smooth' });
    }
  }
});

/*----------------------------------------
　会館一覧のタイトル追従
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

if (window.innerWidth > 768) {
  document.querySelectorAll(".cmn_inner").forEach((section) => {
    const title = section.querySelector(".cmn_plan_ttl");
    if (title) {
      ScrollTrigger.create({
        trigger: section,
        start: "top top+=100",
        end: "bottom top+=150",
        pin: title,
        pinSpacing: false,
        markers: false,
      });
    }
  });
}

/*----------------------------------------
　追従会館の開閉とスムーススクロール
------------------------------------------*/
// if ($('.ceremony').length > 0) {
//   const header = document.querySelector('header');
//   const hallSelect = document.querySelector('.fixed_hall_select');
//   const active = 'is-active';

//   window.addEventListener('scroll', () => {
//     const headerHeight = getHeaderHeight();
//     const hallTop = hallSelect.offsetTop;
//     const scrollY = window.scrollY;

//     if (scrollY + headerHeight >= hallTop) {
//       hallSelect.classList.add('is-sticky');
//       hallSelect.style.left = hallSelect.getBoundingClientRect().left + 'px';
//       hallSelect.style.width = hallSelect.offsetWidth + 'px';
//     } else {
//       hallSelect.classList.remove('is-sticky');
//       hallSelect.style.left = '';
//       hallSelect.style.width = '';
//     }
//   });

//   $('.fixed_hall_btn').on('click', function() {
//     $(this).toggleClass(active);
//     $(this).siblings('.fixed_hall_list').toggleClass(active);
//   });

//   $('.fixed_hall_list a[href^="#"]').on('click', function(e) {
//     e.preventDefault();
//     const targetId = $(this).attr('href');
//     const target = $(targetId);

//     if (target.length) {
//       const headerHeight = getHeaderHeight();
//       const targetOffset = target.offset().top - headerHeight;

//       $('html, body').animate({ scrollTop: targetOffset }, 500);
//     }

//     $('.fixed_hall_btn, .fixed_hall_list').removeClass(active);
//   });
// }

if ($('.ceremony').length > 0) {
  const header = document.querySelector('header');
  const hallSelect = document.querySelector('.fixed_hall_select');
  const active = 'is-active';

  // --- 【最適化】重い計算はスクロール外であらかじめ1回だけやっておく ---
  let headerHeight = getHeaderHeight();
  let hallTop = hallSelect ? hallSelect.offsetTop : 0;
  let initialLeft = 0;
  let initialWidth = 0;

  if (hallSelect) {
    // スティッキー（固定）になる前の、本来の要素のleft位置と横幅を取得
    initialLeft = hallSelect.getBoundingClientRect().left;
    initialWidth = hallSelect.offsetWidth;
  }

  // 画面サイズが変わったときだけ再計算する（スクロール中は触らない）
// 画面サイズが変わったときだけ再計算する（スクロール中は触らない）
  window.addEventListener('resize', () => {
    headerHeight = getHeaderHeight();
    if (hallSelect) {
      // 一度固定用のスタイルをクリアしてから、本来の正しい位置を測り直す
      const wasSticky = hallSelect.classList.contains('is-sticky');
      if (wasSticky) {
        hallSelect.classList.remove('is-sticky');
        hallSelect.style.left = '';
        hallSelect.style.width = '';
      }
      
      // 本来のレイアウト位置を再計測
      hallTop = hallSelect.offsetTop;
      initialLeft = hallSelect.getBoundingClientRect().left;
      initialWidth = hallSelect.offsetWidth;
      
      // スケールを戻す
      if (wasSticky) {
        hallSelect.classList.add('is-sticky');
        hallSelect.style.left = initialLeft + 'px';
        hallSelect.style.width = initialWidth + 'px';
      }
    }
  });
  // -----------------------------------------------------------------

  window.addEventListener('scroll', () => {
    if (!hallSelect) return;
    const scrollY = window.scrollY;

    if (scrollY + headerHeight >= hallTop) {
      // 読み取り（offsetWidthなど）を完全に排除し、あらかじめ測っておいた数値を代入するだけに
      if (!hallSelect.classList.contains('is-sticky')) {
        hallSelect.classList.add('is-sticky');
        hallSelect.style.left = initialLeft + 'px';
        hallSelect.style.width = initialWidth + 'px';
      }
    } else {
      if (hallSelect.classList.contains('is-sticky')) {
        hallSelect.classList.remove('is-sticky');
        hallSelect.style.left = '';
        hallSelect.style.width = '';
      }
    }
  }, { passive: true }); // passive: true をつけるとスクロールパフォーマンスがさらに向上

  // （以下のクリックイベント等は元のコードのままでOKです）
  $('.fixed_hall_btn').on('click', function() {
    $(this).toggleClass(active);
    $(this).siblings('.fixed_hall_list').toggleClass(active);
  });

  $('.fixed_hall_list a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    const targetId = $(this).attr('href');
    const target = $(targetId);

    if (target.length) {
      const currentHeaderHeight = getHeaderHeight(); // ここはそのままでOK
      const targetOffset = target.offset().top - currentHeaderHeight;

      $('html, body').animate({ scrollTop: targetOffset }, 500);
    }

    $('.fixed_hall_btn, .fixed_hall_list').removeClass(active);
  });
}

/*----------------------------------------
　タブ切り替え時のスクロール位置の保存と復元（新着情報・お客様の声）
------------------------------------------*/
document.addEventListener('DOMContentLoaded', function() {
  const newsTabs = document.querySelectorAll('.news_category a');
  const voiceTabs = document.querySelectorAll('.category_list a');

  const saveScrollPosition = () => {
    sessionStorage.setItem('scrollPosition', window.scrollY);
  };

  if (newsTabs.length) {
    newsTabs.forEach(tab => tab.addEventListener('click', saveScrollPosition));
  }
  if (voiceTabs.length) {
    voiceTabs.forEach(tab => tab.addEventListener('click', saveScrollPosition));
  }

  window.addEventListener('load', function() {
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition !== null) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      sessionStorage.removeItem('scrollPosition');
    }
  });
});

/*----------------------------------------
　エコー葬祭の安心Q&Aのタブ切り替え時の設定
------------------------------------------*/
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".faq_tab_list li a");
  if (!tabs.length) return;

  tabs[0].classList.add("active");

  tabs.forEach(tab => {
    tab.addEventListener("click", function(e) {
      e.preventDefault();

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      const targetId = this.getAttribute("href").slice(1);
      const target = document.querySelector('#' + CSS.escape(targetId));
      if (target) {
        const headerHeight = getHeaderHeight();
        const rect = target.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const targetPos = rect.top + scrollTop - headerHeight;

        window.scrollTo({ top: targetPos, behavior: "smooth" });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq_wrap').forEach((faq) => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isOpen = !faq.classList.contains('is-open');

      if (isOpen) {
        faq.classList.add('is-open');
        answer.style.height = '0px';
        requestAnimationFrame(() => {
          answer.style.height = `${answer.scrollHeight}px`;
        });
      } else {
        answer.style.height = `${answer.offsetHeight}px`;
        faq.classList.remove('is-open');
        requestAnimationFrame(() => {
          answer.style.height = '0px';
        });
      }

      question.setAttribute('aria-expanded', String(isOpen));
    });

    answer.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'height' && faq.classList.contains('is-open')) {
        answer.style.height = 'auto';
      }
    });
  });
});

